const en = {
  mifinity_page__stub_title: 'Oops!',
  mifinity_page__stub_text: 'Something went wrong.',
  mifinity_page__stub_contact_support_team: 'Please try again or contact our support team.',
};

const ru = {
  mifinity_page__stub_title: 'Упс!',
  mifinity_page__stub_text: 'Что-то пошло не так.',
  mifinity_page__stub_contact_support_team:
    'Пожалуйста, попробуйте еще раз или свяжитесь с нашей службой поддержки.',
};

const uk = {
  mifinity_page__stub_title: 'Упс!',
  mifinity_page__stub_text: 'Щось пішло не так.',
  mifinity_page__stub_contact_support_team:
    'Спробуйте ще раз або зверніться до нашої служби підтримки.',
};

export default { en, ru, uk };
